import { render, staticRenderFns } from "./emailLogin.vue?vue&type=template&id=644768aa&scoped=true"
import script from "./emailLogin.vue?vue&type=script&lang=ts"
export * from "./emailLogin.vue?vue&type=script&lang=ts"
import style0 from "./emailLogin.vue?vue&type=style&index=0&id=644768aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644768aa",
  null
  
)

export default component.exports